// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__FRJ+8","input":"Landing_input__WYOjC"};